import axios from 'axios'
import store from '../store/store'

export default {
    async login() {
        await store.getters.getPropertyGuid
        await store.getters.getTenantAuthToken
        let loginCredentials = {
            hashedSecret: store.getters.getTenantAuthToken }


        return axios.post(location.origin.toString() + "/residents/properties/"+
            store.getters.getPropertyGuid + "/units/logins",
            loginCredentials
        )
    }
}
